<div *ngIf="hasAnyEquipment()" class="post-equipment-header text-muted small">
  <span
    [ngbTooltip]="translateService.instant('Equipment most recently used by this user')"
    [openDelay]="750"
    class="equipment-info-tooltip"
    container="body"
    placement="top"
  >
    <ng-container *ngIf="equipment.telescope">
      <a [routerLink]="getEquipmentLink('telescope', equipment.telescope.id)" class="text-muted">
        {{ equipment.telescope.brandName || translateService.instant("DIY") }} {{ equipment.telescope.name }}
      </a>
      <ng-container *ngIf="equipment.camera || equipment.mount"> • </ng-container>
    </ng-container>

    <ng-container *ngIf="equipment.camera">
      <a [routerLink]="getEquipmentLink('camera', equipment.camera.id)" class="text-muted">
        {{ equipment.camera.brandName || translateService.instant("DIY") }} {{ equipment.camera.name }}
      </a>
      <ng-container *ngIf="equipment.mount"> • </ng-container>
    </ng-container>

    <ng-container *ngIf="equipment.mount">
      <a [routerLink]="getEquipmentLink('mount', equipment.mount.id)" class="text-muted">
        {{ equipment.mount.brandName || translateService.instant("DIY") }} {{ equipment.mount.name }}
      </a>
    </ng-container>
  </span>
</div>
